// 共通ローカライズメッセージ
// すべてのページで使用

export const common = {
  SuccessMessages: {
    LOADER_MSG: "データを読み込み中です...",
    DELETE_CONFIRMATION_MSG: "この項目を削除してもよろしいですか？",
    LOGIN_SUCCESS_MSG: "ログインに成功しました",
    HEADER_TEXT: "永賢組技術者登録システム",
    FOOTER_TEXT: "All rights reserved, Copyright CloudPower, Inc.",
    REGISTER_SUCCESS: "登録が完了しました。",
    ENTRY_LOGGED: "入場が記録されました。",
    EXIT_LOGGED: "退場が記録されました。",
    SENT_MSG: "送信されました",
    BULK_EDIT_COMPLETED: "一括更新が完了しました！",
    REGISTRATION_MSG: "{0}に登録されました。",
    UPDATED_MSG: "{0}に更新されました。",
    DELETED_MSG: "{0}が削除されました。"
  },
  ErrorMessages: {
    PHONE_REQUIRED_FIELD: "電話番号を入力してください",
    NAME_REQUIRED_FIELD: "氏名を入力してください",
    FACE_NOT_DETECTED: "顔を検出できませんでした。もう一度お試しください。",
    PAGE_NOT_FOUND_ERR: "ページが見つかりません",
    REQUIRED_ERR: "この項目は必須です。",
    NETWORK_ERR: "ネットワークエラーが発生しました。再試行してください。",
    INVALID_INPUT_ERR: "無効な入力です。",
    INVALID_EMAIL_ERR: "有効なメールアドレスを入力してください。",
    INVALID_PHONE_ERR: "有効な電話番号を入力してください",
    UNAUTHORIZED_ERR: "この操作を実行する権限がありません。",
    SERVER_ERR: "サーバーエラーが発生しました。",
    UNKNOWN_ERR: "不明なエラーが発生しました。",
    REQUIRED_VALUE: "{0}を入力してください。",
    REQUIRED_SELECT: "{0}を選択してください。",
    NOT_FOUND: "{0}が見つかりません。",
    INVALID: "{0}が無効です。",
    LOGIN_ERR: "ログインに失敗しました。しばらく経ってから再度お試しください。"
  },
  Labels: {
    LOGIN: "ログイン",
    NEWITEM: "新しいアイテム",
    SAVE: "保存",
    CANCEL: "キャンセル",
    CLOSE: "閉じる",
    REGISTER: "登録",
    EDIT: "編集",
    DELETE: "削除",
    SEARCH: "検索",
    BULKEDIT: "一括編集",
    LIST: "一覧",
    DETAILS: "詳細",
    REQUIRED: "※必須",
    COMPLETION: "完了",
    PHONENUMBER: "電話番号",
    UNDERSTOOD_BUTTON: "わかりました",
    MENU_LBL: "メニュー",
    ENTRANCE_AND_EXIT_MANAGEMENT: "入退場管理",
    WORKER_lIST_BY_SUBCONTRACTOR: "協力業者別作業員名簿",
    KY_ACTIVITY: "KY活動",
    SAFETY_LOG: "安全日誌",
    ONSITE: "現場",
    PARTNER: "協力業者",
    ONSITE_PARTNER_RELATION: "現場協力業者紐付け",
    EMPLOYEE: "社員",
    EMPLOYEE_QUALIFICATION: "社員資格",
    EMPLOYEE_ACHIEVEMENT: "社員実績",
    CLIENT: "契約先",
    RISKY_WORK: "危険作業",
    RISK_AVOIDANCE: "危険回避策",
    HEADQUARTERS: "本社",
    SYSTEM: "システム"
  }
} as const;

export const formatMessage = (msg: string, ...args: string[]): string => {
  return args.reduce((acc, arg, index) => {
    const regex = new RegExp(`\\{${index}\\}`, "g");
    return acc.replace(regex, arg);
  }, msg);
};